import {
    COUNTRY_SLUGS,
    Product,
    TreatmentCase,
    UTSLocale,
} from "@smile2impress/attraction-constants";
import {
    getPriceFromProduct,
    TreatmentPrice,
} from "@smile2impress/attraction-utils";

export default ({
    products = [],
    locale = UTSLocale.SPAIN_ES,
    monthly = true,
    productsFilter = [
        TreatmentCase.LIGHT,
        TreatmentCase.MODERATE,
        TreatmentCase.COMPLEX,
    ],
}: {
    products: Product[];
    locale: UTSLocale;
    monthly?: boolean;
    productsFilter?: (TreatmentCase | string)[];
}) => {
    const countrySlug = COUNTRY_SLUGS[locale];
    const [lowest] = products
        .filter((product) => productsFilter.includes(product.code))
        .map((product) => {
            return Number(
                (
                    getPriceFromProduct(
                        product,
                        countrySlug,
                        "",
                        monthly
                    ) as TreatmentPrice
                )?.current
            );
        })
        .sort((a: number, b: number) => a - b);
    return lowest;
};
